import report from './report'
import user from './user'
import workspaces from './workspaces'
import metadata from './metadata'
import search from './search'
import i18n from './i18n'

export default {
  report,
  user,
  workspaces,
  metadata,
  search,
  i18n
}
